import React from 'react';

import { Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import { t } from '~/helpers';

import * as S from './styles';

const useStyles = makeStyles((theme) => ({
  tooltipText: {
    fontSize: '1.2rem',
    whiteSpace: 'pre-wrap',
  },
}));

export default function Card({
  icon,
  title,
  children,
  tooltip,
  paginacao,
  style,
  disabled,
}) {
  const classes = useStyles();

  return (
    <S.Container style={style} disabled={disabled}>
      {tooltip ? (
        <Tooltip
          title={tooltip}
          classes={{
            tooltip: classes.tooltipText,
          }}
        >
          <header>
            <div className="title">
              {icon}
              <h1>{title}</h1>
            </div>
            <S.Paginacao>{paginacao}</S.Paginacao>
          </header>
        </Tooltip>
      ) : (
        <header>
          <div className="title">
            {icon}
            <h1>{title}</h1>
          </div>
        </header>
      )}
      {disabled ? (
        <S.SemModuloWrapper>
          {t('s.configuracao.geral.modulonaohabilitado')
            .replace(' %s', '')
            .toUpperCase()}
        </S.SemModuloWrapper>
      ) : (
        <div className="card-content">{children}</div>
      )}
    </S.Container>
  );
}

Card.propTypes = {
  icon: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  tooltip: PropTypes.string,
  paginacao: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.any),
  disabled: PropTypes.bool,
};

Card.defaultProps = {
  tooltip: '',
  paginacao: '',
  style: {},
  disabled: false,
};
